import React, { useState, useEffect } from "react";
import { Modal, Button, Form, Container, Row, Col } from 'react-bootstrap';
import APICom from '../../../utils/helpers/APICom';


const EmailCustomer = (props) => {

    const [ showEmailDialog, setEmailDialog] = useState(false);
    const [ customerEmailValue, setCustomerEmailValue] = useState('')
    const [ showEmailCustomerAlert, setEmailCustomerAlert] = useState(false);
    const [ emailCustomerAlertObj, setEmailCustomerAlertObj] = useState({alertTitle: '', alertMsg:''});

    useEffect(() =>{
      if(props.GridRowData === null || props.GridRowData.length <= 0)
      {
        setEmailCustomerAlertObj({...emailCustomerAlertObj, alertTitle: 'No trip selected', alertMsg:'No request selected to perform IRTPU.'});
        setEmailCustomerAlert(true);
      }
      else
      {
        FetchCustomerEmail();       

      }
    }, []);

    const FetchCustomerEmail= async () => {
      const gData = props.GridRowData[0];
      var Param = {
        "iServiceID": gData.ServiceID,
        "TableSource": gData.TableSource,
        "iClientID": gData.ClientID
      }
      let response = await APICom.fetchData("", "TripActions/GetEmailAddressFromReq", "post", { "Content-Type": "application/json" }, Param, null);
      let result = response.data;
      if(result !== '')
      {
        setCustomerEmailValue(result);
      }
      else
      {
        setCustomerEmailValue('');
      }
      setEmailDialog(true);
    }


    const SendEmailToCustomer = async () => {
      const gData = props.GridRowData[0];
      var Param = {
        "iRefID": gData.ConfirmationNo,
        "iATSPID": gData.iSRATSPID,
        "vCustomerEmail": customerEmailValue
      }
      let response = await APICom.fetchData("", "TripActions/SendCustomerEmail", "post", { "Content-Type": "application/json" }, Param, null);
      let result = response.data;
      if(result === 'Success')
      {
        setEmailCustomerAlertObj({...emailCustomerAlertObj, alertTitle: 'Email Receipt', alertMsg:'Email sent successfully.'});
        setEmailCustomerAlert(true);
      }
      else
      {
        setEmailCustomerAlertObj({...emailCustomerAlertObj, alertTitle: 'Email Receipt', alertMsg:'Email not sent.'});
        setEmailCustomerAlert(true);
      }

    }

    const hanldeEmailChange = (e) => {
      setCustomerEmailValue(e.target.value);
    }


    const handleCloseEmailDialog = () => {
      setEmailDialog(false);
      UnMountEmailComponent();
    }

    const handleDroppedAlertClose = () => {
        setEmailCustomerAlert(false);
        UnMountEmailComponent();
      }
    
      const UnMountEmailComponent = () => {
        if(props.emailCustomerComponentLoad)
        {
          props.setEmailCustomerComponentLoad(false);
        }
      }

    return(
        <>
            { showEmailDialog &&
                <Modal show={showEmailDialog}  onHide={handleCloseEmailDialog} animation={false}>
                <Modal.Header className="agentinstruction_dialog_header_bgcolor" closeButton>
                  <Modal.Title className="agentinstruction_dialog_title_color user-select-none">Email Receipt</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                <Container>
                        <Row>
                            <Col xs={6} md={1} className="w-100 user-select-none">Confirmation Number: <b className="mx-2">{props.GridRowData.length > 0 ? props.GridRowData[0]["ConfirmationNo"] : ""}</b></Col>
                        </Row>
                        <Row>
                            <Col xs={6} md={1} className="w-100 user-select-none">Customer Email:  <Form.Control  type="email" value={customerEmailValue} onChange={hanldeEmailChange} autoFocus/></Col>
                        </Row>
                </Container>
                </Modal.Body>
                <Modal.Footer>
                  <Button variant="secondary" onClick={handleCloseEmailDialog}>
                    Cancel
                  </Button>
                  <Button className="agentinstruction_btn_ok" onClick={SendEmailToCustomer}>
                    Send
                  </Button>
                </Modal.Footer>
              </Modal>
            }
            { showEmailCustomerAlert && <Modal centered show={showEmailCustomerAlert} onHide={handleDroppedAlertClose} animation={false} >
                                  <Modal.Header className='activate_dialog_header_bgcolor' style={{height: "50px"}} closeButton>
                                    <Modal.Title className='activate_dialog_title_color'>{emailCustomerAlertObj.alertTitle}</Modal.Title>
                                  </Modal.Header>
                                  <Modal.Body><b>{emailCustomerAlertObj.alertMsg}</b></Modal.Body>
                                  <Modal.Footer>
                                    <Button variant="secondary" onClick={handleDroppedAlertClose}>
                                      Close
                                    </Button>
                                  </Modal.Footer>
                                </Modal>}
        </>
    );
};


export default EmailCustomer;